export enum CallState {
    Calling = "Calling",
    NoResponse = "NoResponse",
    FirstAiderOnTheirWay = "FirstAiderOnTheirWay",
}